module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityMembers) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.nickname')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.leader')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityMembers), function(communityMember) {
    return _c('community-members-row', {
      key: communityMember.uid,
      attrs: {
        "communityMember": communityMember
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityMembers.length >= 10),
      expression: "communityMembers.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.nickname')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.leader')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ad6683c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMembersTable.vue
// module id = 563
// module chunks = 0